import axios from 'axios';
import { getAuthHeader } from '../components/utils';

const API_BASE_URL = 'https://api.instacorp.ae/api/admin/cities';
const ROOT_URL = 'https://api.instacorp.ae/api';

// Cities API
export const cityService = {
  // Get all cities with pagination
  getCities: async (page = 1, limit = 10) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/?page=${page}&limit=${limit}`,
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching cities:', error);
      console.error('Error response:', error.response?.data);
      console.error('Error status:', error.response?.status);
      throw error;
    }
  },

  // Get city by ID
  getCityById: async (cityId) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/${cityId}`,
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching city:', error);
      console.error('Error response:', error.response?.data);
      console.error('Error status:', error.response?.status);
      

      
      throw error;
    }
  },

  // Create new city
  createCity: async (cityData) => {
    try {
      // Create FormData for multipart/form-data request
      const formData = new FormData();
      
      // Add basic fields
      formData.append('name', cityData.name);
      formData.append('status', cityData.status);
      
      // Convert benefits array to JSON string
      if (cityData.benefits && Array.isArray(cityData.benefits)) {
        formData.append('benefits', JSON.stringify(cityData.benefits));
      }
      
      // Add image if provided
      if (cityData.image) {
        formData.append('image', cityData.image);
      }

      const response = await axios.post(
        `${API_BASE_URL}/`,
        formData,
        { 
          headers: {
            ...getAuthHeader(),
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error creating city:', error);
      throw error;
    }
  },

  // Update city
  updateCity: async (cityId, cityData) => {
    try {
      // Create FormData for multipart/form-data request
      const formData = new FormData();
      
      // Add basic fields
      formData.append('name', cityData.name);
      formData.append('status', cityData.status);
      
      // Convert benefits array to JSON string
      if (cityData.benefits && Array.isArray(cityData.benefits)) {
        formData.append('benefits', JSON.stringify(cityData.benefits));
      }
      
      // Add image if provided
      if (cityData.image) {
        formData.append('image', cityData.image);
      }

      const response = await axios.put(
        `${API_BASE_URL}/${cityId}`,
        formData,
        { 
          headers: {
            ...getAuthHeader(),
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error updating city:', error);
      throw error;
    }
  },

  // Delete city
  deleteCity: async (cityId) => {
    try {
      const response = await axios.delete(
        `${API_BASE_URL}/${cityId}`,
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (error) {
      console.error('Error deleting city:', error);
      throw error;
    }
  },

  // Update city status
  updateCityStatus: async (cityId, status) => {
    try {
      const response = await axios.patch(
        `${API_BASE_URL}/${cityId}/status`,
        { status },
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (error) {
      console.error('Error updating city status:', error);
      throw error;
    }
  },

  // Get city benefits
  getCityBenefits: async (cityId) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/${cityId}/benefits`,
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching city benefits:', error);
      throw error;
    }
  }
};

// Freezones API
export const freezoneService = {
  // Get all freezones
  getFreezones: async (page = 1, limit = 10, cityId = null) => {
    try {
      let url = `${API_BASE_URL}/freezones?page=${page}&limit=${limit}`;
      
    
      if (cityId) {
        url += `&cityId=${encodeURIComponent(cityId)}`;
      }
      
      const response = await axios.get(url, { headers: getAuthHeader() });
      console.log('Freezone API response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching freezones:', error);
      console.error('Error response:', error.response?.data);
      console.error('Error status:', error.response?.status);
      console.error('Request URL:', error.config?.url);
      

      
      throw error;
    }
  },

  // Get freezone by ID
  getFreezoneById: async (freezoneId) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/freezones/${freezoneId}`,
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching freezone:', error);
      throw error;
    }
  },

  // Create new freezone
  createFreezone: async (freezoneData) => {
    try {
      console.log('Creating freezone with data:', freezoneData);
      
      // Create FormData for multipart/form-data request
      const formData = new FormData();
      
      // Add basic fields
      formData.append('name', freezoneData.name);
      formData.append('city_id', freezoneData.city_id);
      formData.append('status', freezoneData.status);
      
      // Add optional fields
      if (freezoneData.timeline) {
        formData.append('timeline', freezoneData.timeline);
      }
      if (freezoneData.special_offer) {
        formData.append('special_offer', freezoneData.special_offer);
      }
      
      // Convert benefits array to JSON string
      if (freezoneData.benefits && Array.isArray(freezoneData.benefits)) {
        formData.append('benefits', JSON.stringify(freezoneData.benefits));
      }
      
      // Add image if provided
      if (freezoneData.image) {
        formData.append('image', freezoneData.image);
      }

      // Log FormData contents for debugging
      console.log('FormData contents:');
      for (let [key, value] of formData.entries()) {
        console.log(`${key}:`, value);
      }

      const response = await axios.post(
        `${API_BASE_URL}/freezones`,
        formData,
        { 
          headers: {
            ...getAuthHeader(),
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error creating freezone:', error);
      throw error;
    }
  },

  // Update freezone
  updateFreezone: async (freezoneId, freezoneData) => {
    try {
      // Create FormData for multipart/form-data request
      const formData = new FormData();
      
      // Add basic fields
      formData.append('name', freezoneData.name);
      formData.append('city_id', freezoneData.city_id);
      formData.append('status', freezoneData.status);
      
      // Add optional fields
      if (freezoneData.timeline) {
        formData.append('timeline', freezoneData.timeline);
      }
      if (freezoneData.special_offer) {
        formData.append('special_offer', freezoneData.special_offer);
      }
      
      // Convert benefits array to JSON string
      if (freezoneData.benefits && Array.isArray(freezoneData.benefits)) {
        formData.append('benefits', JSON.stringify(freezoneData.benefits));
      }
      
      // Add image if provided
      if (freezoneData.image) {
        formData.append('image', freezoneData.image);
      }

      const response = await axios.put(
        `${API_BASE_URL}/freezones/${freezoneId}`,
        formData,
        { 
          headers: {
            ...getAuthHeader(),
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error updating freezone:', error);
      throw error;
    }
  },

  // Delete freezone
  deleteFreezone: async (freezoneId) => {
    try {
      const response = await axios.delete(
        `${API_BASE_URL}/freezones/${freezoneId}`,
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (error) {
      console.error('Error deleting freezone:', error);
      throw error;
    }
  },

  // Update freezone status
  updateFreezoneStatus: async (freezoneId, status) => {
    try {
      const response = await axios.patch(
        `${API_BASE_URL}/freezones/${freezoneId}/status`,
        { status },
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (error) {
      console.error('Error updating freezone status:', error);
      throw error;
    }
  },

  // Get freezone benefits
  getFreezoneBenefits: async (freezoneId) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/freezones/${freezoneId}/benefits`,
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching freezone benefits:', error);
      throw error;
    }
  }
};

const toNumber = (value) => {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return value;
  }
  if (typeof value === 'string') {
    const parsed = Number(value);
    if (Number.isFinite(parsed)) {
      return parsed;
    }
  }
  return 0;
};

const normalizeFreezoneCode = (value) => {
  const upper = String(value || '').trim().toUpperCase();
  if (
    upper.includes('IFZA') ||
    upper.includes('INTERNATIONAL FREE ZONE AUTHORITY')
  ) {
    return 'IFZA';
  }
  if (
    upper.includes('SHAMS') ||
    upper.includes('SHARJAH MEDIA CITY') ||
    upper.includes('SHARJAH MEDIA')
  ) {
    return 'SHAMS';
  }
  return upper;
};

const normalizeAdditionalCharges = (rawCharges) => {
  if (!rawCharges) {
    return {};
  }

  if (Array.isArray(rawCharges)) {
    return rawCharges.reduce((acc, row) => {
      if (!row) {
        return acc;
      }
      const chargeName = row.charge_name || row.name;
      const chargeAmount = toNumber(row.charge_amount ?? row.amount);
      const renewalAmount = toNumber(row.renewal_amount);

      if (chargeName) {
        acc[chargeName] = chargeAmount;
        if (renewalAmount > 0) {
          acc[`${chargeName}Renewal`] = renewalAmount;
        }
      }

      return acc;
    }, {});
  }

  return Object.entries(rawCharges).reduce((acc, [key, value]) => {
    acc[key] = toNumber(value);
    return acc;
  }, {});
};

const normalizePackageFees = (pkg) => {
  if (!pkg) {
    return { licenseFee: {}, discountedFee: {} };
  }

  if (pkg.licenseFee || pkg.discountedFee) {
    const licenseFee = Object.entries(pkg.licenseFee || {}).reduce((acc, [year, amount]) => {
      acc[Number(year)] = toNumber(amount);
      return acc;
    }, {});
    const discountedFee = Object.entries(pkg.discountedFee || {}).reduce((acc, [year, amount]) => {
      acc[Number(year)] = toNumber(amount);
      return acc;
    }, {});
    return { licenseFee, discountedFee };
  }

  if (Array.isArray(pkg.license_fees)) {
    const licenseFee = {};
    const discountedFee = {};
    pkg.license_fees.forEach((feeRow) => {
      const duration = Number(feeRow.duration_years);
      if (!Number.isFinite(duration)) {
        return;
      }
      licenseFee[duration] = toNumber(feeRow.regular_fee);
      discountedFee[duration] = toNumber(feeRow.discounted_fee);
    });
    return { licenseFee, discountedFee };
  }

  if (pkg.license_fees && typeof pkg.license_fees === 'object') {
    const licenseFee = {};
    const discountedFee = {};
    Object.entries(pkg.license_fees).forEach(([duration, feeRow]) => {
      const numericDuration = Number(duration);
      if (!Number.isFinite(numericDuration)) {
        return;
      }
      const regularFee = toNumber(
        feeRow?.regular_fee !== undefined ? feeRow.regular_fee : feeRow
      );
      const discounted = toNumber(
        feeRow?.discounted_fee !== undefined ? feeRow.discounted_fee : feeRow
      );
      licenseFee[numericDuration] = regularFee;
      discountedFee[numericDuration] = discounted;
    });
    return { licenseFee, discountedFee };
  }

  return { licenseFee: {}, discountedFee: {} };
};

const normalizePricingEntry = (entry, fallbackFreezoneId = '') => {
  const freezoneId = normalizeFreezoneCode(
    entry?.freezoneId || entry?.freezone_name || fallbackFreezoneId || ''
  );
  const rawLicenseType = entry?.licenseType || entry?.package_type || entry?.packageType?.name;
  const licenseType = rawLicenseType ? String(rawLicenseType).toLowerCase() : undefined;

  const packages = (entry?.packages || [])
    .map((pkg) => {
      const visa = toNumber(pkg?.visa ?? pkg?.visa_count);
      const establishmentCard = toNumber(pkg?.establishmentCard ?? pkg?.establishment_card_fee);
      const establishmentCardRenewalRaw =
        pkg?.establishmentCardRenewal ?? pkg?.establishment_card_renewal_fee;
      const establishmentCardRenewal = toNumber(establishmentCardRenewalRaw);
      const { licenseFee, discountedFee } = normalizePackageFees(pkg);

      return {
        visa,
        licenseFee,
        discountedFee,
        establishmentCard,
        establishmentCardRenewal,
      };
    })
    .filter((pkg) => Number.isFinite(pkg.visa))
    .sort((a, b) => a.visa - b.visa);

  const additionalCharges = normalizeAdditionalCharges(
    entry?.additionalCharges || entry?.additional_charges
  );

  const chargeConfig = entry?.chargeConfig && typeof entry.chargeConfig === 'object'
    ? entry.chargeConfig
    : {};

  return {
    id: `${freezoneId}::${licenseType || 'default'}`,
    freezoneId,
    licenseType,
    packages,
    additionalCharges,
    chargeConfig,
    createdAt: entry?.createdAt || entry?.created_at || null,
    updatedAt: entry?.updatedAt || entry?.updated_at || null,
  };
};

const normalizePricingApiResponse = (payload) => {
  if (!payload) {
    return [];
  }

  if (payload.freezoneId && Array.isArray(payload.packages)) {
    return [normalizePricingEntry(payload, payload.freezoneId)];
  }

  if (payload.success && Array.isArray(payload.pricing)) {
    const fallbackFreezoneId = payload.freezoneId || '';
    return payload.pricing.map((entry) => normalizePricingEntry(entry, fallbackFreezoneId));
  }

  if (Array.isArray(payload)) {
    return payload.map((entry) => normalizePricingEntry(entry));
  }

  if (typeof payload === 'object') {
    const normalized = [];
    Object.entries(payload).forEach(([freezoneId, freezonePricing]) => {
      if (!freezonePricing || typeof freezonePricing !== 'object') {
        return;
      }

      const normalizedFreezoneId = normalizeFreezoneCode(freezoneId);
      const additionalCharges = normalizeAdditionalCharges(freezonePricing.additionalCharges || {});
      const chargeConfig = freezonePricing.chargeConfig || {};

      if (Array.isArray(freezonePricing.packages)) {
        normalized.push(
          normalizePricingEntry(
            {
              freezoneId: normalizedFreezoneId,
              packages: freezonePricing.packages,
              additionalCharges,
              chargeConfig,
            },
            normalizedFreezoneId
          )
        );
      }

      Object.entries(freezonePricing).forEach(([key, value]) => {
        if (key === 'packages' || key === 'additionalCharges' || key === 'chargeConfig') {
          return;
        }
        if (Array.isArray(value)) {
          normalized.push(
            normalizePricingEntry(
              {
                freezoneId: normalizedFreezoneId,
                licenseType: key,
                packages: value,
                additionalCharges,
                chargeConfig,
              },
              normalizedFreezoneId
            )
          );
        }
      });
    });

    return normalized;
  }

  return [];
};

const normalizePackagesForApi = (packages = []) =>
  packages.map((pkg) => ({
    visa: toNumber(pkg.visa),
    licenseFee: Object.entries(pkg.licenseFee || {}).reduce((acc, [year, amount]) => {
      acc[Number(year)] = toNumber(amount);
      return acc;
    }, {}),
    discountedFee: Object.entries(pkg.discountedFee || {}).reduce((acc, [year, amount]) => {
      acc[Number(year)] = toNumber(amount);
      return acc;
    }, {}),
    establishmentCard: toNumber(pkg.establishmentCard),
    establishmentCardRenewal: toNumber(pkg.establishmentCardRenewal),
  }));

// Pricing API
export const pricingService = {
  // Get pricing structures
  getPricingStructures: async (page = 1, limit = 10, freezoneId = null, packageType = null) => {
    try {
      const response = await axios.get(`${ROOT_URL}/pricing`, { headers: getAuthHeader() });
      let rows = normalizePricingApiResponse(response.data);

      if (freezoneId) {
        const normalizedFreezoneId = String(freezoneId).toUpperCase();
        rows = rows.filter((row) => row.freezoneId === normalizedFreezoneId);
      }

      if (packageType) {
        const normalizedPackageType = String(packageType).toLowerCase();
        rows = rows.filter((row) => (row.licenseType || '') === normalizedPackageType);
      }

      return {
        success: true,
        pricing: rows.slice((page - 1) * limit, page * limit),
        total: rows.length,
      };
    } catch (error) {
      console.error('Error fetching pricing structures:', error);
      throw error;
    }
  },

  // Get pricing by identifier (`FREEZONE::type`) or fallback endpoint
  getPricingById: async (pricingId) => {
    try {
      if (String(pricingId).includes('::')) {
        const allPricing = await pricingService.getPricingStructures(1, 500);
        const record = (allPricing.pricing || []).find((item) => item.id === pricingId);
        return { success: true, pricing: record || null };
      }

      const response = await axios.get(`${ROOT_URL}/pricing/${pricingId}`, {
        headers: getAuthHeader(),
      });
      const normalized = normalizePricingApiResponse(response.data);
      return { success: true, pricing: normalized[0] || null };
    } catch (error) {
      console.error('Error fetching pricing:', error);
      throw error;
    }
  },

  // Get pricing by freezone and package type
  getPricingByFreezoneAndPackage: async (_cityId, freezoneId, packageType) => {
    const response = await pricingService.getPricingStructures(1, 500, freezoneId, packageType);
    const match = (response.pricing || [])[0] || null;
    return { success: true, pricing: match };
  },

  // Create pricing structure (upsert)
  createPricing: async (pricingData) => {
    try {
      const payload = {
        freezoneId: normalizeFreezoneCode(pricingData.freezoneId || pricingData.freezone_id || ''),
        licenseType: pricingData.licenseType ? String(pricingData.licenseType).toLowerCase() : undefined,
        packages: normalizePackagesForApi(pricingData.packages || []),
        additionalCharges: normalizeAdditionalCharges(
          pricingData.additionalCharges || pricingData.additional_charges || {}
        ),
        chargeConfig: pricingData.chargeConfig || {},
      };

      const response = await axios.post(`${ROOT_URL}/pricing`, payload, {
        headers: getAuthHeader(),
      });
      return response.data;
    } catch (error) {
      console.error('Error creating pricing:', error);
      throw error;
    }
  },

  // Update pricing structure (same endpoint, upsert semantics)
  updatePricing: async (_pricingId, pricingData) => pricingService.createPricing(pricingData),

  // Delete pricing structure by freezone + optional licenseType
  deletePricing: async (pricingScope, maybeLicenseType = null) => {
    try {
      let freezoneId = '';
      let licenseType = maybeLicenseType;

      if (typeof pricingScope === 'object' && pricingScope !== null) {
        freezoneId = normalizeFreezoneCode(pricingScope.freezoneId || '');
        licenseType = pricingScope.licenseType || null;
      } else if (typeof pricingScope === 'string' && pricingScope.includes('::')) {
        const [fz, type] = pricingScope.split('::');
        freezoneId = normalizeFreezoneCode(fz || '');
        licenseType = type === 'default' ? null : type;
      } else {
        freezoneId = normalizeFreezoneCode(pricingScope || '');
      }

      const query = licenseType ? `?licenseType=${encodeURIComponent(licenseType)}` : '';
      const response = await axios.delete(`${ROOT_URL}/pricing/${freezoneId}${query}`, {
        headers: getAuthHeader(),
      });
      return response.data;
    } catch (error) {
      console.error('Error deleting pricing:', error);
      throw error;
    }
  },

  // Get all pricing entries for a freezone code (e.g. IFZA, SHAMS)
  getPricingForFreezone: async (freezoneCode, options = {}) => {
    const normalizedCode = normalizeFreezoneCode(freezoneCode);
    const fallbackName = String(options.freezoneName || '').trim();
    const candidates = Array.from(
      new Set(
        [normalizedCode, normalizeFreezoneCode(fallbackName), fallbackName]
          .map((value) => String(value || '').trim())
          .filter(Boolean)
      )
    );

    // First source: grouped /pricing response (works for SHAMS media/standard docs)
    try {
      const allPricing = await pricingService.getPricingStructures(1, 500);
      const rows = allPricing.pricing || [];
      const matchedRows = rows.filter((row) =>
        candidates.includes(String(row.freezoneId || '').trim())
      );
      if (matchedRows.length > 0) {
        return matchedRows;
      }
    } catch (error) {
      console.error('Error fetching grouped pricing for freezone:', error);
    }

    // Fallback source: direct /pricing/:freezone endpoint lookups
    for (const candidate of candidates) {
      try {
        const response = await axios.get(`${ROOT_URL}/pricing/${encodeURIComponent(candidate)}`, {
          headers: getAuthHeader(),
        });
        const normalizedRows = normalizePricingApiResponse(response.data).map((row) => ({
          ...row,
          freezoneId: normalizeFreezoneCode(row.freezoneId || candidate),
        }));

        if (normalizedRows.length > 0) {
          return normalizedRows;
        }
      } catch (error) {
        if (error?.response?.status === 404) {
          continue;
        }
        console.error('Error fetching pricing for freezone:', error);
        throw error;
      }
    }

    // SHAMS specific fallback when grouped lookup is unavailable
    if (normalizedCode === 'SHAMS') {
      const shamsRows = [];
      for (const type of ['media', 'standard']) {
        try {
          const response = await axios.get(
            `${ROOT_URL}/pricing/SHAMS?licenseType=${type}`,
            { headers: getAuthHeader() }
          );
          const normalizedRows = normalizePricingApiResponse(response.data).map((row) => ({
            ...row,
            freezoneId: 'SHAMS',
          }));
          shamsRows.push(...normalizedRows);
        } catch (error) {
          if (error?.response?.status !== 404) {
            console.error('Error fetching SHAMS pricing type:', type, error);
          }
        }
      }
      if (shamsRows.length > 0) {
        return shamsRows;
      }
    }

    return [];
  },

  // Get license packages for a freezone
  getLicensePackages: async (cityId, freezoneId, packageType = null) => {
    try {
      let url = `${API_BASE_URL}/freezones/${freezoneId}/packages?cityId=${cityId}`;
      if (packageType) {
        url += `&packageType=${packageType}`;
      }
      const response = await axios.get(url, { headers: getAuthHeader() });
      return response.data;
    } catch (error) {
      console.error('Error fetching license packages:', error);
      throw error;
    }
  },

  // Get license fees for a package
  getLicenseFees: async (packageId) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/packages/${packageId}/fees`,
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching license fees:', error);
      throw error;
    }
  },

  // Get additional charges for a freezone
  getAdditionalCharges: async (cityId, freezoneId) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/freezones/${freezoneId}/charges?cityId=${cityId}`,
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching additional charges:', error);
      throw error;
    }
  }
};

// Package Types API
export const packageTypeService = {
  // Get all package types
  getPackageTypes: async () => {
    try {
      console.log('Fetching package types from API...');
      const headers = getAuthHeader();
      
      console.log('Package types API URL:', `${API_BASE_URL}/package-types`);
      const response = await axios.get(
        `${API_BASE_URL}/package-types`,
        { headers }
      );
      console.log('Package types API response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching package types:', error);
      throw error;
    }
  },

  // Create package type
  createPackageType: async (packageTypeData) => {
    try {
      console.log('Creating package type with data:', packageTypeData);
      const response = await axios.post(
        `${API_BASE_URL}/package-types`,
        packageTypeData,
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (error) {
      console.error('Error creating package type:', error);
      throw error;
    }
  },

  // Update package type
  updatePackageType: async (packageTypeId, packageTypeData) => {
    try {
      console.log('Updating package type with data:', packageTypeData);
      const response = await axios.put(
        `${API_BASE_URL}/package-types/${packageTypeId}`,
        packageTypeData,
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (error) {
      console.error('Error updating package type:', error);
      throw error;
    }
  },

  // Delete package type
  deletePackageType: async (packageTypeId) => {
    try {
      const response = await axios.delete(
        `${API_BASE_URL}/package-types/${packageTypeId}`,
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (error) {
      console.error('Error deleting package type:', error);
      throw error;
    }
  },


  // Get freezone by ID
  getFreezoneById: async (freezoneId) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/freezones/${freezoneId}`,
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching freezone:', error);
      console.error('Error response:', error.response?.data);
      console.error('Error status:', error.response?.status);
      

      
      throw error;
    }
  },

  // Get pricing by freezone
  getPricingByFreezone: async (freezoneId) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/pricing?freezoneId=${freezoneId}`,
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching pricing by freezone:', error);
      console.error('Error response:', error.response?.data);
      console.error('Error status:', error.response?.status);
      
     
      
      throw error;
    }
  },

  // Get pricing by ID
  getPricingById: async (pricingId) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/pricing/${pricingId}`,
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching pricing by ID:', error);
      console.error('Error response:', error.response?.data);
      console.error('Error status:', error.response?.status);
      
    
      
      throw error;
    }
  },

  // Delete pricing
  deletePricing: async (pricingId) => {
    try {
      const response = await axios.delete(
        `${API_BASE_URL}/pricing/${pricingId}`,
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (error) {
      console.error('Error deleting pricing:', error);
      throw error;
    }
  }
};

// Image upload service
export const imageService = {
  // Upload image
  uploadImage: async (file, type = 'city') => {
    try {
      const formData = new FormData();
      formData.append('image', file);
      formData.append('type', type);

      const response = await axios.post(
        `${API_BASE_URL}/upload/image`,
        formData,
        {
          headers: {
            ...getAuthHeader(),
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error uploading image:', error);
      throw error;
    }
  }
};

// Export all services
const cityServiceModule = {
  cityService,
  freezoneService,
  pricingService,
  packageTypeService,
  imageService,
};
export default cityServiceModule; 
